import React from "react";
import { themeTextRed } from "../../helpers/theme";
import '../styles/common.scss';

const LeftArrow = (props) => {
  return (
    <>
      <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.53478 8.53553L1.99924 5L5.53478 1.46447" stroke={themeTextRed} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </>
  );
};
export default LeftArrow;
